<template>
  <b-modal
    v-model="showModal"
    id="modal-warning-noti"
    class="modal-warning-noti"
    hide-footer
    hide-header
    centered
    no-close-on-backdrop
  >
    <div class="d-flex justify-content-end top-modal">
      <div>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="$emit('close-modal')"
        />
      </div>
    </div>
    <div class="text-center">
      <img
        class="notification-img"
        alt="alert"
        :src="require('@/assets/images/common/ic-notification.png')"
      >
      <p class="font-24 font-weight-600 mt-md-1">
        Important Notice
      </p>
    </div>
    <!--    <div class="d-md-none text-center">-->
    <!--      <p>Ecomdy has updated our Binance wallet address starting April 10th.</p>-->
    <!--      <p>Please double-check the address with support team before making any payments to avoid errors.</p>-->
    <!--      <user-hint />-->
    <!--    </div>-->
    <div>
      <p class="mb-50">
        {{ platformName }} has updated our Binance wallet address on Solana Network (SOL) starting April 28th.
      </p>
      <p style="margin-bottom: 4px">
        Kindly use the new details below for all future transactions:
      </p>
      <div>
        <ul>
          <li class="w-100 list-style-circle">
            <p class="mb-0">
              SOL (Solana):
            </p>
            <div class="d-flex justify-content-between">
              <p
                class="mb-0"
                style="overflow-wrap: break-word; width: calc(100% - 24px)"
              >
                CSKkAMH1Sew3pu1WAoBSNe1p6kfBaWRjMDnX7yQxseNJ
              </p>
              <b-img
                class="tool cursor-pointer"
                fluid
                alt="img"
                width="16px"
                :src="require('@/assets/images/pages/payment/ic-copy.svg')"
                @click="handleCopy('CSKkAMH1Sew3pu1WAoBSNe1p6kfBaWRjMDnX7yQxseNJ')"
              />
            </div>
          </li>
        </ul>
      </div>
      <p class="mt-50">
        ⚠️ Please double-check the address before making any payments to avoid errors.
      </p>
      <user-hint />
    </div>
  </b-modal>
</template>
<script>
/* eslint-disable camelcase */
import {
  BImg,
  BModal,
} from 'bootstrap-vue'
import paymentMixin from '@/mixins/paymentMixin'
import UserHint from '@/components/UserHint.vue'
import envMixin from '@/mixins/envMixin'
import { toastification } from '@core/mixins/toast'

export default {
  components: {
    BImg,
    UserHint,
    BModal,
  },
  mixins: [paymentMixin, envMixin, toastification],
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.show,
    }
  },

  computed: {
    usdtPaymentInfo() {
      return this.generalConfigs?.paymentInfo?.USDT
    },

    binanceNetwork() {
      return this.usdtPaymentInfo?.info?.find(item => item.additionalInfo.usdtChain === 'Binance User ID')
    },

    otherNetworks() {
      return this.usdtPaymentInfo?.info?.filter(item => item.additionalInfo.usdtChain !== 'Binance User ID')
    },
  },
  watch: {
    show: {
      handler(val) {
        this.showModal = val
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleCopy(wallet) {
      window.navigator.clipboard.writeText(wallet).then(() => {
        this.toastSuccess(this.$t('payment.contentCopiedId'))
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-warning-noti {
  .modal-body {
    padding: 20px;
  }
}
</style>
<style lang="scss">
#modal-warning-noti {
  .modal-body {
    padding: 20px 28px !important;
  }

  .modal-dialog {
    @media (min-width: 768px) {
      max-width: 550px !important;
    }
  }

  .notification-img {
    width: 170px;
    margin-top: -130px;

    @media (max-width: 768px) {
      margin-top: -110px;
      width: 100px;
    }
  }
}

.text-black {
  color: #000000;
}

.text-gray {
  color: #353535;
}
</style>
